export const PrivateChat = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_3894_16824)">
      <g filter="url(#filter0_d_3894_16824)">
        <path
          d="M12.6666 5.33333V4.66667C12.6666 3.42899 12.1749 2.242 11.2998 1.36684C10.4246 0.491665 9.2376 0 7.99992 0C6.76224 0 5.57526 0.491665 4.70009 1.36684C3.82492 2.242 3.33325 3.42899 3.33325 4.66667V5.33333H1.33325V14C1.33325 14.5304 1.54397 15.0391 1.91904 15.4142C2.29411 15.7893 2.80282 16 3.33325 16H12.6666C13.197 16 13.7057 15.7893 14.0808 15.4142C14.4559 15.0391 14.6666 14.5304 14.6666 14V5.33333H12.6666ZM8.66659 12H7.33325V9.33333H8.66659V12ZM11.3333 5.33333H4.66659V4.66667C4.66659 3.78261 5.01777 2.93477 5.6429 2.30964C6.26802 1.68452 7.11586 1.33333 7.99992 1.33333C8.88397 1.33333 9.73182 1.68452 10.3569 2.30964C10.9821 2.93477 11.3333 3.78261 11.3333 4.66667V5.33333Z"
          fill="url(#paint0_linear_3894_16824)"
        />
        <path
          d="M12.6666 5.33333V4.66667C12.6666 3.42899 12.1749 2.242 11.2998 1.36684C10.4246 0.491665 9.2376 0 7.99992 0C6.76224 0 5.57526 0.491665 4.70009 1.36684C3.82492 2.242 3.33325 3.42899 3.33325 4.66667V5.33333H1.33325V14C1.33325 14.5304 1.54397 15.0391 1.91904 15.4142C2.29411 15.7893 2.80282 16 3.33325 16H12.6666C13.197 16 13.7057 15.7893 14.0808 15.4142C14.4559 15.0391 14.6666 14.5304 14.6666 14V5.33333H12.6666ZM8.66659 12H7.33325V9.33333H8.66659V12ZM11.3333 5.33333H4.66659V4.66667C4.66659 3.78261 5.01777 2.93477 5.6429 2.30964C6.26802 1.68452 7.11586 1.33333 7.99992 1.33333C8.88397 1.33333 9.73182 1.68452 10.3569 2.30964C10.9821 2.93477 11.3333 3.78261 11.3333 4.66667V5.33333Z"
          fill="url(#paint1_linear_3894_16824)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_3894_16824"
        x="-3.66675"
        y="-2"
        width="23.3333"
        height="26"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3894_16824"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3894_16824"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3894_16824"
        x1="7.99992"
        y1="0"
        x2="7.99992"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0BBCF" />
        <stop offset="1" stopColor="#968FA9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3894_16824"
        x1="7.99992"
        y1="0"
        x2="7.99992"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9878FD" />
        <stop offset="1" stopColor="#482F99" />
      </linearGradient>
      <clipPath id="clip0_3894_16824">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
